import { render, staticRenderFns } from "./OnlineCourseList.vue?vue&type=template&id=2487515a&scoped=true"
import script from "./OnlineCourseList.vue?vue&type=script&lang=js"
export * from "./OnlineCourseList.vue?vue&type=script&lang=js"
import style0 from "./OnlineCourseList.vue?vue&type=style&index=0&id=2487515a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2487515a",
  null
  
)

export default component.exports